import { createAsyncThunk } from '@reduxjs/toolkit'
import { ResBusinessDefaultsType } from '../../contexts/FodContainerContext/types'
import { postConfig, headersConfig } from './utils'
import type { ApprovalReq, ApprovalRes, ContextInitState, NavLinks, ThemeInitState, LogisticsReq, UpdateLogisticsData } from './types'
import type { FleetManagementFetchProps } from '../../components/FleetManagement/types'
import type { ResTotalParams } from './types/resTotal'
import { getCSRFToken } from '@view/utils/getCSRFToken'

export const fetchInitContext = createAsyncThunk('businessThemeContext', async () => {
	const response = await fetch(`/ajax/get-business-theme-context/`, { ...headersConfig })
	const context: ContextInitState = await response.json()
	const mod = await import(`./../../../src/react-apps/themes/${context.siteTheme}`)
	const theme: ThemeInitState = await mod.default
	let approvals: ApprovalRes | { success: 0 } = { success: 0 }
	if (context) {
		// const headers = postConfig({
		// 	businessId: context.currentBusinessId,
		// 	fieldType: 'Customer',
		// 	fieldValue: context.currentBusinessId,
		// 	numDays: 0,
		// 	setAddresses: false,
		// 	rentalReservation: null,
		// })
		// if (context.siteTheme != 'fod-sui') {
		// 	const approvalResult = await fetch(`/ajax/get-field-approval-requirement/`, { ...headers })
		// 	approvals = await approvalResult.json()
		// }
	}
	return { context, theme, approvals }
})

export const fetchNavLinks = createAsyncThunk('navLinks', async () => {
	const response = await fetch(`/ajax/get-nav-links/`)
	const data: NavLinks = await response.json()
	return data
})
export const fetchSecureForm = createAsyncThunk('secureForm', async () => {
	const response = await fetch('/ajax/get-new-res-edit-form/')
	const data = await response.json()
	return data
})

export const fetchFleetManagementVehicles = createAsyncThunk(
	'fleetManagementVehicles',
	async ({ businessId = '', all = 0, step }: { businessId?: string; all?: number; step: number }, thunkApi) => {
		const response = await fetch(`/ajax/fleet-management/get-fleet-management/?businessId=${businessId}&step=${step}&all=${all}/`, {
			...headersConfig,
			signal: thunkApi.signal,
		})
		const data: FleetManagementFetchProps = await response.json()
		return data
	}
)
export const fetchResApproval = createAsyncThunk('resApproval', async (args: ApprovalReq) => {
	const headers = postConfig(args)
	const response = await fetch(`/ajax/get-field-approval-requirement/`, { ...headers })
	const data: ApprovalRes = await response.json()
	return data
})

export const fetchIndexDefaults = createAsyncThunk('indexDefaults', async ({ id }, { signal }) => {
	const response = await fetch(`/ajax/get-res-business-index-defaults/?id=${id}/`, { ...headersConfig, signal })
	const data: ResBusinessDefaultsType = await response.json()

	return { ...data }
})
export const fetchBusinessDefaults = createAsyncThunk('businessDefaults', async ({ id, cuiPanelId }, { signal }) => {
	const response = await fetch(`/ajax/get-res-business-defaults/?id=${id}&cuiPanelId=${cuiPanelId}`, { ...headersConfig, signal })
	const checkWhatToHide = await fetch(`/ajax/check-what-to-hide/${id}`, { signal }).then(res => res.json())
	const data: ResBusinessDefaultsType = await response.json()

	return { ...data, ...checkWhatToHide }
})

export const fetchRentalTotal = createAsyncThunk(
	'rentalTotal',
	async ({ tariffBandId, numDays, vehicleGroupId }: ResTotalParams, thunkApi) => {
		const response = await fetch(
			`/ajax/get-rental-price/?tariffBandId=${tariffBandId}&totalDays=${numDays}&vehicleGroupId=${vehicleGroupId}`,
			{ ...headersConfig, signal: thunkApi.signal }
		)
		const data: { total: string; rate: string } = await response.json()
		return data
	}
)

export const fetchLogisticsData = createAsyncThunk('logisticsData', async ({ reservationId, allotmentId, category }: LogisticsReq) => {
	let url: string
	// This check is because the logistics endpoint url differs slightly to the other categories
	if (category === 'logistic-plan') {
		url = `/rental/reservation/${reservationId}/vehicle-allotment/${allotmentId}/logistic-plan/`
	} else {
		url = `/rental/reservation/${reservationId}/vehicle-allotment/${allotmentId}/query/${category}/`
	}
	const response = await fetch(url, {
		...headersConfig,
	})
	const data = await response.json()
	return data
})

export const updateLogisticsData = createAsyncThunk('updateLogisticsData', async ({ allotmentId }: UpdateLogisticsData) => {
	const response = await fetch('/ajax/update-logistics-plan.php', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'x-react': 'useReact',
			'X-CSRF-Token': getCSRFToken(),
		},
		body: JSON.stringify({
			allotmentId,
		}),
	})

	const data = await response.json()

	return data
})
